import React from "react";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const PromoFloatingLabelInputField = ({
    errors,
    label,
    type,
    field,
    register,
    height = "",
    style = "",
    disabled,
    icon,
    defaultValue = "",
}) => {
    return (
        <div className="flex-1">
            <div className={`relative`}>
                <input
                    type={type}
                    id={field}
                    name={field}
                    {...register(field)}
                    className={`w-full h-12 pb-2.5 px-4 pt-6  ${disabled ? "bg-Ghost_White" : "bg-white"} rounded-[1px] outline-1 outline-offset-[-1px] outline ${disabled ? "outline-[#2E7D32]" : "outline-[#ece9ee]"} focus:outline-neutral-800 appearance-none peer ${disabled ? "" : "text-sm font-light"} font-Poppins text-[#262626]`}
                    placeholder=" "
                    defaultValue={defaultValue}
                    disabled={disabled}
                />
                <label
                    htmlFor={field}
                    className={`absolute left-4 text-sm font-Poppins font-light text-[#666666] leading-[21px] transition-all duration-300 
                    peer-focus:text-[10px] peer-focus:sm:text-[12px] peer-focus:font-normal peer-focus:text-[#333333] peer-focus:leading-[15px] peer-focus:top-[3px]
                    peer-[&:not(:placeholder-shown)]:text-[10px] peer-[&:not(:placeholder-shown)]:top-[3px] peer-[&:not(:placeholder-shown)]:font-normal ${disabled ? "peer-[&:not(:placeholder-shown)]:text-Quick_Silver" : "peer-[&:not(:placeholder-shown)]:text-[#333333]"} peer-[&:not(:placeholder-shown)]:leading-[15px]
                    peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
                    peer-focus:translate-y-0`}
                >
                    {label}
                </label>
                {icon && <div className={` ${disabled ? "absolute" : "hidden"}  inset-0 flex justify-end items-center pr-4`}>
                    <img src={icon} />

                </div>}
            </div>
            <ErrorTextWithIcon text={errors?.[field]?.message} />
        </div>
    );
};

export default PromoFloatingLabelInputField;
